import React, { useEffect } from 'react';
import cn from 'classnames';
import { NavMenus } from '@src/constant/navLinks';
import styles from './index.module.scss';
import ShareIcon from '../ShareIcon';
import { scrollToAnchor } from '@src/lib/utils';

const MenuItem = ({ title, options, link, isDark, onClick }) => {
    const fontColor = isDark ? '#101010' : '#fff';
    if (link && (!options || options.length === 0)) {
        return (
            <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(styles.menuItem, {
                    [styles.dark]: isDark,
                })}
            >
                <div className={styles.title}>{title}</div>
            </a>
        );
    }
    return (
        <div
            className={cn(styles.menuItem, {
                [styles.dark]: isDark,
            })}
        >
            <div className={styles.title}>{title}</div>
            <div className={styles.options}>
                {options &&
                    options.map(({ title: optionTitle, hasIcon, link: optionLink, localLink }) => {
                        if (optionLink) {
                            return (
                                <a
                                    href={optionLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.item}
                                    key={optionTitle}
                                >
                                    <div>{optionTitle}</div>
                                    {hasIcon && (
                                        <ShareIcon className={styles.icon} color={fontColor} />
                                    )}
                                </a>
                            );
                        }
                        return (
                            <div
                                className={styles.item}
                                key={optionTitle}
                                onClick={() => onClick(localLink)}
                            >
                                <div>{optionTitle}</div>
                                {hasIcon && (
                                    <ShareIcon className={styles.icon} color={fontColor} />
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default function MobileMenu({ open, isDark, onClose }) {
    useEffect(() => {
        if (open) {
            const scrollY = window.scrollY;
            window.scrollTo(0, 0);
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
            }
        }
    }, [open]);

    const handleClick = (localLink) => {
        onClose?.();
        if (localLink) {
            const hash = localLink.split('#')[1];
            const currentHash = window.location.hash.substring(1);
            if (hash && hash === currentHash) {
                const targetDom = window.document.querySelector(`[name="${hash}"]`);
                if (targetDom) {
                    scrollToAnchor(targetDom, {
                        behavior: 'smooth',
                    });
                    return;
                }
            }
            window.location.hash = '/';
            window.location.replace(localLink);
        }
    };

    return (
        <div
            className={cn(styles.root, {
                [styles.open]: open,
                [styles.whiteTheme]: isDark,
            })}
            aria-hidden={!open}
        >
            <div className={styles.menu}>
                {NavMenus.map(({ title, subMenus, link }) => (
                    <MenuItem
                        key={title}
                        title={title}
                        options={subMenus}
                        link={link}
                        isDark={isDark}
                        onClick={handleClick}
                    />
                ))}
            </div>
        </div>
    );
}
